import { useMemo } from "react";
import { MANAGER_SELF_OPTION_VALUE } from "AppConstants";
import { buildUserOptions, MEMBER_VALUE_USER_ID } from "utils/effortUserFilter";

/**
 * The Member / Manager dropdown's options: one entry per person under the two headings,
 * plus the logged-in manager's own "(Me)" entry when they have a manager record.
 *
 * A person holding a record at several clients appears once — the reports and the export
 * both aggregate across their records, so per-client entries offered a choice that changed
 * nothing. `memberValue` picks which id space the member entries carry.
 * @since NEXT_VERSION
 */
export const useUserFilterOptions = ({
  members = [],
  managers = [],
  memberValue = MEMBER_VALUE_USER_ID,
  self = null,
} = {}) => {
  const { memberOptions, managerOptions } = useMemo(
    () => buildUserOptions({ members, managers, memberValue }),
    [members, managers, memberValue]
  );

  // Offered only once the manager's own record has resolved — selecting it before then
  // would send a report request with no owner to root at.
  const selfOption = useMemo(
    () =>
      self?.id != null
        ? { value: MANAGER_SELF_OPTION_VALUE, label: self.name ? `${self.name} (Me)` : "(Me)" }
        : null,
    [self]
  );

  return { memberOptions, managerOptions, selfOption };
};

export default useUserFilterOptions;
